module.exports = __webpack_public_path__ + "img/avatar.d26f6704.png";